module.exports = __webpack_public_path__ + "a07bae7c82116b14ea8866903c6c228c.jpg";